export default {
    beforeMount(el) {
        const screenWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(screenWidth < 992) {
            el.src = el.srcset
        }
    }
}
